import {
  DateField,
  Datagrid,
  Edit,
  EditButton,
  Filter,
  List,
  Resource,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from "react-admin";

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Article Reference" source="reference" alwaysOn />
  </Filter>
);

const ArticlesList = (props) => (
  <List {...props} filters={<Filters />} bulkActionButtons={false}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="reference" label="Article Reference" />
      <DateField source="createdAt" label="Created at" />
      <DateField source="updatedAt" label="Updated at" />
      <EditButton />
    </Datagrid>
  </List>
);

const ShowArticles = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="reference" label="Article Reference" />
      <DateField source="createdAt" label="Created at" />
      <DateField source="updatedAt" label="Updated at" />
    </SimpleShowLayout>
  </Show>
);

const EditArticle = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id" label="ID" disabled />
      <TextInput source="reference" label="Article Reference" />
      <TextInput source="createdAt" label="Created at" disabled />
      <TextInput source="updatedAt" label="Updated at" disabled />
    </SimpleForm>
  </Edit>
);

const articlesResource = () => (
  <Resource
    name="articles"
    options={{ label: "Historical Articles", menuGroup: "Articles" }}
    list={ArticlesList}
    edit={EditArticle}
    show={ShowArticles}
  />
);

export default articlesResource;
